import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'gender'
})
export class GenderPipe implements PipeTransform {

  transform(value: string, lang: string = 'fa'): any {
    const Men = (lang === 'fa' ? 'مرد' : 'male');
    const Women = (lang === 'fa' ? 'زن' : 'female');
    if (value === 'M') { return Men; }
    if (value === 'F') { return Women; }
  }

}
